<nav class="navbar sticky-top navbar-dark bg-dark navbar-expand-lg">
  <div class="container-fluid">
    <ul class="navbar-nav">
      <li class="nav-item navbar-brand">
        <a class="text-white" routerLink="/">
          <i class="fa fa-store"></i>
          <ng-container *ngIf="activeStorefront$ | async as sf else defaultStore">
            {{sf.name}}
          </ng-container>
          <ng-template #defaultStore>
            Boostability
          </ng-template>
        </a>
      </li>
      <ng-container *ngTemplateOutlet="activeLinkSet$ | async"></ng-container>
    </ul>
    <ul class="navbar-nav ms-auto" *ngIf="activeUser$ | async as user">
      <li class="nav-item">
        <a href="{{user.returnUrl}}" class="btn btn-primary"><i class="fas fa-arrow-left"></i> Launchpad</a>
      </li>
      <li>
        <app-customer-summary *ngIf="customer$ | async as customer" [customer]="customer"></app-customer-summary>
      </li>
    </ul>
  </div>
</nav>

<ng-template #customerLinks>
  <li class="nav-item">
    <a class="nav-link" routerLink="/subscriptions" routerLinkActive="active">Subscriptions</a>
  </li>
  <li class="nav-item">
    <a class="nav-link" routerLink="/orders" routerLinkActive="active">Orders</a>
  </li>
  <li class="nav-item">
    <a class="nav-link" routerLink="/customer/payment-methods" routerLinkActive="active">Payment Methods</a>
  </li>
  <li class="nav-item">
    <a class="nav-link" routerLink="/place-order" routerLinkActive="active">Place Order</a>
  </li>
</ng-template>

<ng-template #storefrontLinks>
  <ng-container *ngIf="activeStorefront$ | async as storefront">
    <li class="nav-item" *ngxPermissionsOnly="permissions.viewAllStorefronts">
      <a routerLink="/storefront/all" class="nav-link">Change Storefront</a>
    </li>
    <li class="nav-item">
      <a class="nav-link" routerLink="/storefront" routerLinkActive="active"
        [routerLinkActiveOptions]="{ exact: true }">
        Catalog
      </a>
    </li>
    <li *ngxPermissionsOnly="[permissions.managementWriteLimited, permissions.managementWriteLimited]" class="nav-item">
      <a class="nav-link" routerLink="/storefront/categories" routerLinkActive="active">Categories</a>
    </li>
    <li class="nav-item">
      <a class="nav-link" routerLink="/storefront/payments" routerLinkActive="active">Payments</a>
    </li>
  </ng-container>
</ng-template>
